<template>
    <div>
        <el-dialog width="50%" :visible="dialogVisible"  @close="cancel">
            <div class="content">
                <el-table :data="tableData"
                          v-loading="dataListLoading"
                          ref="expertExtractTable"
                          stripe border>
                    <el-table-column
                            fixed
                            label="序号"
                            type="index"
                            :index="indexMethod"
                            width="50"
                            align="center"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column label="评审专家" prop="name" align="left" width="150px"
                                     :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="是否回避" prop="isAvoid" align="left" width="120px"
                                     :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{ scope.row.isAvoid == '1'?"回避":(scope.row.isAvoid == '2'?"不回避":"没结果")}}
                        </template>
                    </el-table-column>
                    <el-table-column label="回避原因" prop="avoidReason" align="left"
                                     min-width="200px" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
                <pagination
                        class="limit"
                        v-if="false"
                        :page-sizes="[10, 20, 50, 100]"
                        :total="total"
                        :page.sync="pageIndex"
                        :limit.sync="pageSize"
                        @pagination="paginationChange"
                >
                </pagination>
            </div>
            <span slot="footer">
                <el-button @click="cancel">取消</el-button>
            </span>

        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            dataListLoading:false,
            tableData: [],
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            agree: null,
            modelStep: 1,
        }
    },
    computed: {

    },
    methods: {
        closed() {
            this.dialogVisible = false
            this.$emit('closed')
        },
        cancel() {
            this.closed()
        },
        init(params) {
            this.dialogVisible = true;
            this.getListData(params)
        },
        //获取列表数据
        getListData(params) {
            this.$http.post(`/evaluation/getExpertAvoid/${params.bidSectionId}`, {
                page: this.pageIndex,
                rows: this.pageSize,
            }).then((res) => {
                this.tableData = res.data;
                this.total = res.data.length || 0;
            });
        },
        //分页
        paginationChange({page, limit}) {
            this.pageIndex = page;
            this.pageSize = limit;
            this.getListData();
        },
        //序号
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
    }

}
</script>

<style lang="less" scoped>
.title {
    font-size: 16px;
    a {
        margin-left: 10px;
    }
    .warning {
        color: #f90;
    }
    .info {
        color: #2db7f5;
    }

}

/deep/ .el-dialog__header {
    padding-top: 18px;
}

</style>